import React from 'react';

import truck10TSizeSvg from '@assets/img/icons/delivery-guidance/10T-size.svg';
import truck10TSvg from '@assets/img/icons/delivery-guidance/10T.svg';
import truck4TSizeSvg from '@assets/img/icons/delivery-guidance/4T-size.svg';
import truck4TSvg from '@assets/img/icons/delivery-guidance/4T.svg';
import truck4Tx2SizeSvg from '@assets/img/icons/delivery-guidance/4Tx2-size.svg';
import truck4Tx2Svg from '@assets/img/icons/delivery-guidance/4Tx2.svg';
import cargoSize1Svg from '@assets/img/icons/delivery-guidance/cargo-size-1.svg';
import cargoSize2Svg from '@assets/img/icons/delivery-guidance/cargo-size-2.svg';
import cargoSize3Svg from '@assets/img/icons/delivery-guidance/cargo-size-3.svg';
import circleSvg from '@assets/img/icons/delivery-guidance/circle.svg';
import crossSvg from '@assets/img/icons/delivery-guidance/cross.svg';
import truckMixSizeSvg from '@assets/img/icons/delivery-guidance/mix-size.svg';
import truckMixSvg from '@assets/img/icons/delivery-guidance/mix.svg';
import { ActionableDialog, ActionableDialogTitle } from '@components/Dialog';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';

const useStyles = makeMuiStyles((theme, common) => ({
  dialog: {
    maxWidth: '960px !important',
    paddingBottom: '2rem',
  },
  truckInfoTable: {
    backgroundColor: theme.palette.grey[100],
    display: 'grid',
    gridTemplateColumns: 'max-content 2px 1fr 1fr 1fr 1fr',
    gridAutoColumns: 'max-content',
  },
  divider: {
    backgroundColor: theme.palette.background.paper,
  },
  truckInfoHead: {
    ...common.flexColumn,
    ...common.smallerText,
    ...common.fontWeight600,
    textAlign: 'center',
    padding: '1rem',
    justifyContent: 'center',
  },
  truckInfoImage: {
    ...common.flexColumn,
    paddingTop: '2rem',
    paddingBottom: '1rem',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  truckInfoDescription: {
    ...common.smallerText,
    ...common.textGray600,
    padding: '0 0.5rem',
  },
  specifyTimeImage: {
    ...common.flexCenter,
    padding: '2rem 0.5rem',
  },
}));

const strings = createStrings({
  ja: {
    title: 'トラック種類の違い',
    truckType: 'トラック種類',
    size: 'サイズ',
    cargoSize: 'お荷物の量',
    specifyTime: '時間指定',
    typeDescriptions: [
      '混載便とは1台のトラックに複数社のお客様の荷物を一緒に積載して輸送するサービスのことです。',
      'チャ－ター便(4T)は4トントラック一台を借り切って荷物を運送するサービスです。',
      'チャ－ター便(10T)は10トントラック一台を借り切って荷物を運送するサービスです。',
      'チャーター便(4T×2台)は4トントラック二台を借り切って荷物を運送するサービスです。',
    ],
    sizeDescriptions: [
      'トラックの車種(4Tもしくは10T)はご指定いただけません。',
      '4トントラックのサイズ目安　長さ:620cm/幅:220cm/積載重量制限:2750kgs/積載容積制限:18m³',
      '10トントラックのサイズ目安　長さ:950cm/幅:235cm/積載重量制限:9850kgs/積載容積制限:35m³',
      '4トントラックのサイズ目安　長さ:620cm/幅:220cm/積載重量制限:2750kgs/積載容積制限:18m³',
    ],
    cargoSizeDescriptions: [
      '少量のお荷物の場合、チャーター便よりコスト削減できます。',
      'トラックの一台あたりの料金なので、お荷物の量が多い場合に最適です。',
      'トラックの一台あたりの料金なので、お荷物の量が多い場合に最適です。',
      '道幅が狭く10トントラックが進入できない場合に最適です。',
    ],
  },
});

export interface DeliveryInstructionTruckInfoDialogProps {
  open: boolean;
  onClose: () => void;
}

export const DeliveryInstructionTruckInfoDialog: React.FC<
  DeliveryInstructionTruckInfoDialogProps
> = (props) => {
  const { open, onClose } = props;

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <ActionableDialog
      open={open}
      onClose={onClose}
      classes={{
        paper: classes.dialog,
      }}
    >
      <ActionableDialogTitle>{strings.title}</ActionableDialogTitle>
      <div className={classes.truckInfoTable}>
        <div className={classes.truckInfoHead} style={{ gridRow: 'span 2' }}>
          {strings.truckType}
        </div>
        <div className={classes.divider} />
        <div className={classes.truckInfoImage}>
          <img src={truckMixSvg} style={{ height: 64, width: 105 }} />
        </div>
        <div className={classes.truckInfoImage}>
          <img src={truck4TSvg} style={{ height: 64, width: 105 }} />
        </div>
        <div className={classes.truckInfoImage}>
          <img src={truck10TSvg} style={{ height: 75, width: 108 }} />
        </div>
        <div className={classes.truckInfoImage}>
          <img src={truck4Tx2Svg} style={{ height: 66, width: 204 }} />
        </div>
        <div className={classes.divider} />
        {strings.typeDescriptions.map((description, index) => (
          <div key={index} className={classes.truckInfoDescription}>
            {description}
          </div>
        ))}
        <div className={classes.truckInfoHead} style={{ gridRow: 'span 2' }}>
          {strings.size}
        </div>
        <div className={classes.divider} />
        <div className={classes.truckInfoImage}>
          <img src={truckMixSizeSvg} style={{ height: 45, width: 141.5 }} />
        </div>
        <div className={classes.truckInfoImage}>
          <img src={truck4TSizeSvg} style={{ height: 45, width: 141.5 }} />
        </div>
        <div className={classes.truckInfoImage}>
          <img src={truck10TSizeSvg} style={{ height: 45, width: 141.5 }} />
        </div>
        <div className={classes.truckInfoImage}>
          <img src={truck4Tx2SizeSvg} style={{ height: 45, width: 141.5 }} />
        </div>
        <div className={classes.divider} />
        {strings.sizeDescriptions.map((description, index) => (
          <div key={index} className={classes.truckInfoDescription}>
            {description}
          </div>
        ))}
        <div className={classes.truckInfoHead} style={{ gridRow: 'span 2' }}>
          {strings.cargoSize}
        </div>
        <div className={classes.divider} />
        <div className={classes.truckInfoImage}>
          <img src={cargoSize1Svg} style={{ height: 28, width: 43 }} />
        </div>
        <div className={classes.truckInfoImage}>
          <img src={cargoSize2Svg} style={{ height: 28, width: 88 }} />
        </div>
        <div className={classes.truckInfoImage}>
          <img src={cargoSize3Svg} style={{ height: 46, width: 70 }} />
        </div>
        <div className={classes.truckInfoImage}>
          <img src={cargoSize3Svg} style={{ height: 46, width: 70 }} />
        </div>
        <div className={classes.divider} />
        {strings.cargoSizeDescriptions.map((description, index) => (
          <div key={index} className={classes.truckInfoDescription}>
            {description}
          </div>
        ))}
        <div className={classes.truckInfoHead}>{strings.specifyTime}</div>
        <div className={classes.divider} />
        <div className={classes.specifyTimeImage}>
          <img src={crossSvg} style={{ height: 20, width: 20 }} />
        </div>
        <div className={classes.specifyTimeImage}>
          <img src={circleSvg} style={{ height: 20, width: 20 }} />
        </div>
        <div className={classes.specifyTimeImage}>
          <img src={circleSvg} style={{ height: 20, width: 20 }} />
        </div>
        <div className={classes.specifyTimeImage}>
          <img src={circleSvg} style={{ height: 20, width: 20 }} />
        </div>
      </div>
    </ActionableDialog>
  );
};
